var RwAjaxContent = (function () {


  // Inietta Html restituito dal file inc/moduli/func-ajax-content.php
  // La security è definita in inc/enqueue.php da rw_ajax_obj

  // I parametri template e anno vengono passati dal file custom.js es.
  // if (typeof RwAjaxContent != 'undefined') {
  //   $('#ajaxTest').on('click', function(e) {
  //     template = $(this).attr('template');
  //     anno = $(this).attr('anno');
  //
  //     RwAjaxContent.richiama_contenuto(template, anno);
  //     console.log(template + ' ' + anno);
  //   });
  // }


  var richiama_contenuto = function (template, anno) {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_content',
        security : rw_ajax_obj.ajax_nonce,

        // Variabili passate al file inc/moduli/func-ajax-content.php
        // che permettono di fare una query in base a template e anno
        template : template,
        anno : anno
      },
      beforeSend: function() {
      },
      success : function( response ) {
        $('#content').html( response );
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
        // window.history.replaceState({}, document.title, '/info/testajax');
      }
    });

  };

  var content = function () {
    richiama_contenuto();
  };


  return {
    richiama_contenuto : richiama_contenuto
  }


})();
